import { render, staticRenderFns } from "./AamsBaseSealApprovalPermission.vue?vue&type=template&id=9f0d684c&scoped=true&"
import script from "./AamsBaseSealApprovalPermission.vue?vue&type=script&lang=js&"
export * from "./AamsBaseSealApprovalPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0d684c",
  null
  
)

export default component.exports